// v1.1.0 · Contenido de la web pública (rediseño). Los datos de contacto y logos de clientes salen de mock.js
//           para no duplicarlos.
import { contactData, clientsData } from './mock';

export { contactData };

// Logo servido desde el propio dominio (frontend/public)
export const LOGO = '/logo_analytica.png';

// v1.21.0 · Reserva directa de la llamada (página de reservas del CRM)
export const BOOKING_URL = '/reservar/asesoria-comercial?utm_source=web&utm_medium=organic&utm_campaign=portada';

export const nav = [
  { label: 'Servicios', href: '#servicios' },
  { label: 'Qué construimos', href: '#construimos' },
  { label: 'Proyectos', href: '#proyectos' },
  { label: 'Garantías', href: '#garantias' },
  { label: 'Preguntas', href: '#preguntas' },
  { label: 'Contacto', href: '#contacto' },
];

// v1.21.0 · Capítulos de la portada inmersiva. El orden es el de las formas de la escultura (sculpt.js):
//           portada · retail · telecom · talento · apps · demo.
export const services = [
  {
    key: 'portada', kind: 'intro', short: 'Inicio',
    title: 'Su operación ya existe. Le falta el sistema.',
    lead: 'Construimos el software de cómo trabaja su empresa, no un paquete genérico. Cuéntenos su proceso y en 48 horas '
      + 'le mostramos un demo de cómo funcionará.',
  },
  {
    key: 'retail', short: 'Retail y consumo masivo', name: 'Retail y consumo masivo',
    lead: 'Exhibición, acuerdos comerciales e inventario en el celular de cada mercaderista, con evidencia de cada punto de venta.',
    items: ['Control de exhibición en percha con fotos y ubicación', 'Acuerdos con cadenas y su cumplimiento por local',
      'Inventario, pedidos y reposición por punto de venta'],
    proof: 'Lo construimos para distribuidoras y farmacias en Ecuador.',
  },
  {
    key: 'telecom', short: 'Telecomunicaciones / ISP', name: 'Telecomunicaciones e ISP',
    lead: 'Del pedido de instalación al cierre en casa del cliente, sin grupos de WhatsApp ni hojas de cálculo.',
    items: ['Órdenes de trabajo y agenda de técnicos por zona', 'Aprovisionamiento y equipos controlados por serie',
      'Asistente de WhatsApp que agenda la visita con el cliente'],
    proof: 'Hoy opera las instalaciones y el soporte de un proveedor de internet.',
  },
  {
    key: 'talento', short: 'Talento humano', name: 'Talento humano',
    lead: 'Asistencia, nómina y solicitudes del personal en un solo lugar, sin datos biométricos.',
    items: ['Asistencia con código QR y ubicación desde el celular', 'Roles de pago, horas extra y vacaciones',
      'Permisos y aprobaciones que llegan al jefe correcto'],
  },
  {
    key: 'apps', short: 'Apps, automatización e IA', name: 'Apps, automatización e IA',
    lead: 'Lo que hoy se copia a mano de un sistema a otro, que lo haga el sistema.',
    items: ['Apps móviles que funcionan sin señal', 'Integración con Odoo y el ERP que ya usa',
      'Asistentes con IA que responden por WhatsApp y piden aprobación'],
  },
  {
    key: 'demo', kind: 'demo', short: 'Demo en 48 h', name: 'Véalo funcionando en 48 horas',
    lead: 'Cuéntenos en una llamada de 30 minutos cómo trabaja hoy. En 48 horas le mostramos un demo de cómo funcionará '
      + 'su sistema, con su propio proceso. El demo no es la entrega: es para que decida con algo en la mano.',
  },
];

export const hero = {
  title: 'De hojas de cálculo a sistema propio en 60 días.',
  subtitle:
    'Somos una fábrica de software en Quito. Diseñamos, construimos y ponemos en producción sistemas a la medida ' +
    'para empresas de Ecuador y Latinoamérica.',
  ctaPrimary: 'Cotizar mi proyecto',
  ctaSecondary: 'Escribir por WhatsApp',
};

// v1.3.0 · Recorrido de 60 días del hero: qué ve el visitante en cada tramo de la regla
export const heroStages = [
  { from: 1, key: 'hoy', label: 'Así llega', text: 'Hojas de cálculo, grupos de WhatsApp y llamadas. Nadie sabe con certeza qué está pendiente.' },
  { from: 6, key: 'diagnostico', label: 'Diagnóstico', text: 'Recorremos el proceso con quienes lo viven y marcamos dónde se pierde la información.' },
  { from: 15, key: 'diseno', label: 'Diseño', text: 'Ves las pantallas y el flujo antes de escribir código, y las ajustamos contigo.' },
  { from: 22, key: 'pruebas', label: 'Construcción', text: 'Cada semana tu equipo prueba avances reales en un ambiente de pruebas.' },
  { from: 60, key: 'produccion', label: 'En producción', text: 'El sistema sale en vivo con tus datos migrados y tu equipo capacitado.' },
];

// Clientes reales con logo (se muestran en la franja de confianza del hero)
const LOGO_NAMES = ['Alfanet', 'Neuromatemáticas JASQ', 'Turismo MDD', 'Farmacias Cruz Azul', 'DIFARE'];
export const trustLogos = LOGO_NAMES
  .map((n) => clientsData.clients.find((c) => c.name === n))
  .filter(Boolean)
  .map((c) => ({ name: c.name, logo: c.logo }));

export const capabilities = [
  {
    group: 'Sistemas para operar',
    lead: 'El núcleo de la empresa, hecho a su medida.',
    items: [
      { name: 'ERP e inventarios', text: 'Multi-bodega, compras, producción y trazabilidad por lote y serie.' },
      { name: 'Field service', text: 'Órdenes de trabajo, agendamiento, cierre con fotos y geo-validación.' },
      { name: 'CRM y ventas', text: 'Pipeline, seguimiento automático y reportes por vendedor.' },
      { name: 'Punto de venta', text: 'POS que funciona sin internet, multi-caja y con facturación electrónica.' },
    ],
  },
  {
    group: 'Plataformas y apps',
    lead: 'Lo que usan tus clientes, técnicos y conductores.',
    items: [
      { name: 'Apps móviles', text: 'iOS y Android para equipos en campo, con mapa, fotos y firma.' },
      { name: 'Portales de clientes', text: 'Pedidos, pagos, contratos y seguimiento en un solo acceso.' },
      { name: 'Plataformas educativas', text: 'Clases en vivo, pizarra compartida, evaluaciones y grabaciones.' },
      { name: 'Despacho y flotas', text: 'Asignación automática por cercanía y monitoreo en tiempo real.' },
    ],
  },
  {
    group: 'Datos y automatización',
    lead: 'Menos trabajo manual, mejores decisiones.',
    items: [
      { name: 'Dashboards y BI', text: 'Indicadores por sucursal, simuladores y alertas.' },
      { name: 'Asistentes en WhatsApp', text: 'Pedidos, agendamiento y soporte que entienden texto, voz y ubicación.' },
      { name: 'Captura de datos', text: 'Precios de competencia, catálogos y portales públicos, a escala.' },
      { name: 'Automatización de procesos', text: 'Aprobaciones, recordatorios y reportes que se generan solos.' },
    ],
  },
  {
    group: 'Hecho para Ecuador',
    lead: 'Integraciones que ya resolvimos.',
    items: [
      { name: 'SRI', text: 'Comprobantes electrónicos, formularios 104, 103 y 102, anexos.' },
      { name: 'Firma electrónica', text: 'Firma PAdES con certificados .p12 del BCE y sello de tiempo.' },
      { name: 'Pagos', text: 'PayPhone, PayPal, Stripe, transferencias y conciliación.' },
      { name: 'ERP existentes', text: 'Integración con Odoo y sistemas que ya usa tu empresa.' },
    ],
  },
];

// Proyectos reales. «ui» elige la mini interfaz que se dibuja junto al caso.
export const projects = [
  {
    id: 'alfanet',
    ui: 'ot',
    client: 'Alfanet',
    country: 'Ecuador',
    year: 2026,
    name: 'Alfa-Field Connect',
    kind: 'Orquestador de operaciones para una red de internet por fibra',
    before: 'Cientos de órdenes de trabajo por semana coordinadas por Excel y WhatsApp, sin trazabilidad de materiales.',
    after:
      'Agendamiento por zona, app móvil para técnicos con cierre geo-validado, inventario por bodega con series, ' +
      'monitoreo GPS en vivo e integración con Odoo.',
    metrics: [
      { value: '−68 %', label: 'tiempo de cierre de OT' },
      { value: '228', label: 'reglas de negocio auditables' },
      { value: '35 de 35', label: 'observaciones de QA cerradas' },
    ],
    link: 'https://alfafiel.analytica-ec.com',
  },
  {
    id: 'difare',
    ui: 'precios',
    client: 'Farmacias Cruz Azul y DIFARE',
    country: 'Ecuador',
    year: 2026,
    name: 'Analytica Pro',
    kind: 'Análisis de mercado farmacéutico: CPI y posicionamiento',
    before: 'Precios de la competencia en hojas de Excel que llegaban 15 días tarde.',
    after:
      'Captura en campo, cruce automático con los maestros comerciales y tableros por competidor y laboratorio, ' +
      'con simulador de márgenes.',
    metrics: [
      { value: '3', label: 'vistas de análisis con detalle por producto' },
      { value: '10+', label: 'fuentes de datos normalizadas' },
      { value: '37,7 %', label: 'datos atípicos depurados' },
    ],
    link: 'https://difare.analytica-ec.com',
  },
  {
    id: 'turismo',
    ui: 'despacho',
    client: 'Turismo Madre de Dios',
    country: 'Perú',
    year: 2026,
    name: 'Movilidad tipo Uber',
    kind: 'App de pasajero, app de conductor y despacho para una flota de taxis',
    before: 'Más de 20 años despachando por radio y teléfono, sin registro de carreras ni verificación del pasajero.',
    after:
      'Panel para operadores, apps para conductores y pasajeros, pedidos por WhatsApp con voz o ubicación y ' +
      'asignación automática del conductor más cercano.',
    metrics: [
      { value: '3', label: 'canales de pedido en un solo panel' },
      { value: '≤ 15 km', label: 'radio de asignación automática' },
      { value: 'PIN', label: 'de verificación en cada viaje' },
    ],
    link: 'https://turismo.mdd.analytica-ec.com',
  },
  {
    id: 'neuro',
    ui: 'clase',
    client: 'Neuromatemáticas JASQ',
    country: 'México',
    year: 2026,
    name: 'Neuromatemáticas',
    kind: 'Plataforma educativa que cruza cómo se siente cada estudiante con cuánto sabe',
    before: 'Clases por Zoom, materiales en Drive y avisos por WhatsApp; las grabaciones no se veían en iPhone.',
    after:
      'Clases en vivo con pizarra matemática compartida, evaluaciones en tiempo real, recordatorios automáticos y ' +
      'grabaciones livianas compatibles con todos los dispositivos.',
    metrics: [
      { value: '12+', label: 'franquicias en la plataforma' },
      { value: '100 %', label: 'grabaciones compatibles con iOS' },
      { value: '2', label: 'recordatorios automáticos, 24 h y 2 h antes de clase' },
    ],
  },,
  {
    id: 'retail',
    ui: 'inventario',
    client: 'Retail Solutions S.A.',
    country: 'Ecuador',
    year: 2025,
    name: 'Logística para retail',
    kind: 'Del centro de distribución a 8 sucursales, sin quiebres de stock',
    before: 'Stock en Excel replicado en 8 sucursales, con errores de 5 a 10 % al mes y quiebres constantes de productos estrella.',
    after: 'Inventario centralizado con lectura de código de barras, alertas de reposición por sucursal, sincronización con el punto de venta y reportes diarios.',
    metrics: [
      { value: '−40 %', label: 'quiebres de stock' },
      { value: '20 h', label: 'de trabajo manual ahorradas por semana' },
      { value: '100 %', label: 'trazabilidad de movimientos' },
    ],
  },
  {
    id: 'crm',
    ui: 'crm',
    client: 'Servicios Integrados',
    country: 'Ecuador',
    year: 2025,
    name: 'CRM comercial',
    kind: 'Comportamiento del consumidor y buyer persona',
    before: 'Vendedores con WhatsApp personal y hojas de Excel: se perdían oportunidades y no se podía medir la productividad.',
    after: 'Embudo de ventas visual, plantillas de correo y WhatsApp, seguimiento automático a los 3, 7 y 15 días, y reportes de conversión por vendedor.',
    metrics: [
      { value: '+32 %', label: 'tasa de conversión' },
      { value: '−50 %', label: 'duración del ciclo comercial' },
      { value: '1.er mes', label: 'en recuperar la inversión' },
    ],
  }
];

// Días del proyecto (se dibujan como un cronograma de 60 días)
export const method = [
  { days: [1, 14], when: 'Días 1 a 14', title: 'Diagnóstico', text: 'Recorremos tu operación con quienes la viven y definimos el alcance por escrito.' },
  { days: [8, 21], when: 'Días 8 a 21', title: 'Diseño', text: 'Ves las pantallas y el flujo antes de escribir código, y los ajustamos contigo.' },
  { days: [15, 50], when: 'Días 15 a 50', title: 'Construcción', text: 'Cada semana entregamos avances en un ambiente de pruebas que tu equipo puede usar.' },
  { days: [45, 60], when: 'Días 45 a 60', title: 'Puesta en producción', text: 'Migramos datos, capacitamos al equipo y el sistema sale en vivo.' },
];

export const reach = {
  countries: [
    { name: 'Ecuador', flag: 'ec', projects: 10 },
    { name: 'Perú', flag: 'pe', projects: 8 },
    { name: 'México', flag: 'mx', projects: 5 },
    { name: 'Colombia', flag: 'co', projects: 3 },
    { name: 'Estados Unidos', flag: 'us', projects: 2 },
    { name: 'Argentina', flag: 'ar', projects: 2 },
  ],
  sectors: [
    'Telecomunicaciones', 'Farmacéutico', 'Educación', 'Transporte', 'Retail', 'Servicios profesionales',
    'Manufactura', 'Inmobiliario', 'Turismo', 'Finanzas',
  ],
};

export const projectTypes = [
  'Sistema interno o ERP',
  'App móvil',
  'Plataforma web o portal',
  'Integración o automatización',
  'Aún no lo tengo claro',
  'Otra',   // v1.6.0 · abre un campo para describirla
];

export const timelines = ['Lo antes posible', 'En 1 a 3 meses', 'Estoy evaluando opciones'];

// v1.2.0 · Compromisos del contrato tipo de Analytica (backend/services/contract_template_service.py)
export const heroAssurances = ['Precio total cerrado', '12 meses de garantía', 'Pagos por hitos aprobados'];

export const guarantees = [
  {
    title: 'Doce meses de garantía técnica',
    text: 'Después de la entrega final corregimos cualquier falla, error de lógica o problema de integración atribuible al desarrollo.',
    clause: 'Cláusula 19.ª',
  },
  {
    title: 'Pagas por avance aprobado',
    text: 'El precio total queda fijado en el contrato y cada pago se vincula a un hito que tu equipo revisa y aprueba por escrito.',
    clause: 'Cláusulas 9.ª y 17.ª',
  },
  {
    title: 'Sin cambios por sorpresa',
    text: 'Todo ajuste de alcance se documenta como orden de cambio con su impacto en tiempo y costo, y solo avanza con la firma de ambas partes.',
    clause: 'Cláusula 18.ª',
  },
  {
    title: 'Tu información no sale de tu proyecto',
    text: 'Confidencialidad por al menos cinco años. Tus datos no se usan para entrenar modelos ni para trabajar con otros clientes.',
    clause: 'Cláusulas 10.ª y 11.ª',
  },
  {
    title: 'Disponibilidad del 99,5 %',
    text: 'Cuando operamos el sistema en la nube, garantizamos una disponibilidad anual mínima del 99,5 % y avisamos cada mantenimiento con 48 horas.',
    clause: 'Cláusula 14.ª',
  },
];

export const faq = [
  {
    q: '¿Cuánto cuesta un sistema a la medida?',
    a: 'Depende del alcance. Después del diagnóstico te entregamos una propuesta con el precio total cerrado y un cronograma de pagos atado a hitos que tu equipo aprueba por escrito.',
  },
  {
    q: '¿Qué pasa después de los 60 días?',
    a: 'El sistema queda en producción con 12 meses de garantía técnica. Si lo prefieres, también lo operamos en la nube con una disponibilidad anual mínima del 99,5 %, o tu equipo lo administra directamente.',
  },
  {
    q: '¿Y si necesitamos cambiar algo a mitad del proyecto?',
    a: 'Lo registramos como orden de cambio, con su impacto en tiempo y costo. Nada cambia en el alcance sin la aprobación escrita de ambas partes.',
  },
  {
    q: '¿Se puede integrar con los sistemas que ya usamos?',
    a: 'Sí. Ya trabajamos con Odoo, el SRI, PayPhone, PayPal, Stripe, WhatsApp y bases de datos existentes. En el diagnóstico revisamos qué conviene integrar y qué conviene reemplazar.',
  },
  {
    q: '¿Trabajan con empresas fuera de Ecuador?',
    a: 'Sí. Tenemos proyectos en Perú, México, Colombia, Estados Unidos y Argentina. Las entregas semanales se revisan en línea.',
  },
];
